// eslint-disable-next-line no-restricted-imports
import type * as OriginalTypes from '@forto-dev/booking-v2-api'
// eslint-disable-next-line no-restricted-imports
export * from '@forto-dev/booking-v2-api'

// TODO: Currently the dev server doesn't behave properly when exporting enums from the API client
// This is a workaround to make the code compile
// The better solution would be to provide booking-v2 client in esm format
// eslint-disable-next-line no-restricted-imports
export {
  BookingDTOBookingParty,
  BookingDTOControllingParty,
  BookingDTOCustomsDestinationCustomsType,
  BookingDTOCustomsOriginCustomsType,
  BookingDTOIncotermNamedPlaceOfDelivery,
  BookingDTOInitiatorParty,
  BookingDTOState,
  BookingDTOTransportMode,
  BookingDTOTransportType,
  CreateBookingDTOTransportType,
  ExplicitlyApprovedByControllingPartyDTOType,
  GetPricingResponseDTOPricingType,
  IncotermDTOCode,
  IncotermDTONamedPlaceOfDelivery,
  InsuranceDTOCommodityClass,
  SustainabilityDTOSelectedProduct,
  SustainabilityDTOServiceType,
  WaypointBaseDTOTransportMode,
  WaypointTypes,
} from '@forto-dev/booking-v2-api'

export const waypointIDs = {
  originDoor: 'originDoor',
  originPort: 'originPort',
  destinationPort: 'destinationPort',
  destinationDoor: 'destinationDoor',
}

export enum PricingServiceID {
  CustomsImport = 'customs-import',
  CustomsExport = 'customs-export',
  DoorCarriageDestination = 'door-carriage-destination',
  DoorCarriageOrigin = 'door-carriage-origin',
  SeaFreight = 'sea-freight',
  Insurance = 'insurance',
  Sustainability = 'sustainability',
  LocalHandlingOrigin = 'local-handling-origin',
  LocalHandlingDestination = 'local-handling-destination',
}

export interface CreateBookingDTO
  extends Omit<
    OriginalTypes.CreateBookingDTO,
    | 'waypoints'
    | 'transportMode'
    | 'originPort'
    | 'destinationPort'
    | 'pickupAddress'
    | 'deliveryAddress'
    | 'pickupAddressDetails'
    | 'deliveryAddressDetails'
    | 'bookingParty'
    | 'cargo'
    | 'requestedQuotation'
    | 'isBookedByAgent'
    | 'deliveryDueAt'
    | 'isBCOBooking'
    | 'customerReference'
    | 'legalEntityID'
    | 'originHandlingAgent'
    | 'destinationHandlingAgent'
    | 'notifyParty'
    | 'serviceType'
    | 'transportScope'
  > {
  controllingParty?: OriginalTypes.BookingDTOControllingParty
  waypoints: OriginalTypes.BookingDTOWaypointsInner[]
  shipperLegalEntityCompanyName?: string
  consigneeLegalEntityCompanyName?: string
}

export type BookingDTO = Omit<
  OriginalTypes.BookingDTO,
  | 'transportMode'
  | 'waypoints'
  | 'originPort'
  | 'destinationPort'
  | 'pickupAddress'
  | 'deliveryAddress'
  | 'pickupAddressDetails'
  | 'deliveryAddressDetails'
> & {
  waypoints: OriginalTypes.BookingDTOWaypointsInner[]
}

export type PaginatedBookingsDTO = Omit<OriginalTypes.PaginatedBookingsDTO, 'items'> & {
  items: BookingDTO[]
}
